module.exports = __webpack_public_path__ + "img/pig.49d82727.webp";